/// <reference path="../../../typings/browser.d.ts" />
namespace Application.Controllers {
    'use strict';

    const MAX_RESULTS_DISPLAYED = 15;
    export interface ISONHostnameModalScope extends ng.IScope {
        matchedHostnames: Models.ISONDNSEntry[];
        searchAsType: () => void;
        sonEntry: Models.ISONDNSEntry;
        modalClose: () => void;
        moreResults: number;
        selectHostname: (entry: number) => boolean;
        title: string;
        selectType: "block" | "node";
    }

    export class SONHostnameModalController {
        public static templateUrl: string = "decorators/modals/son-hostname-modal.html";
        public static ID: string = "#id-son-hostname-node-modal";
        public static $name: string = "sonHostnameModalController";
        public static $inject: string[] = ['$scope',
            'close',
            'title',
            'selectType',
            'nodeHostname',
            'networkNodeType',
            'sonAdapterService',
            '$timeout',
        ];

        private sonHostnameTimeout: ng.IPromise<void>;
        private dnsMap: Models.ISONDnsMap;

        constructor(private $scope: ISONHostnameModalScope,
                    private close: (parameters: Models.ISONDNSEntry) => void,
                    private title: string,
                    private selectType: "node" | "block",
                    private nodeHostname: string,
                    private networkNodeType: Models.INetworkNodeType,
                    private sonAdapterService: Services.SonAdapterService,
                    private $timeout: ng.ITimeoutService
        ) {

            this.$scope.title = this.title;
            this.$scope.selectType = this.selectType;
            this.$scope.sonEntry = {
                ip: "",
                hostname: this.nodeHostname ? this.nodeHostname : "",
                isIpRange: false,
            };

            this.$scope.searchAsType = () => {
                if ($scope.sonEntry.hostname !== undefined) {
                    this.$timeout.cancel(this.sonHostnameTimeout);
                    if ($scope.sonEntry.hostname.length < 3) {
                        $scope.matchedHostnames = undefined;
                        $scope.moreResults = 0;
                    } else {
                        this.sonHostnameTimeout = this.$timeout(() => {
                            $scope.matchedHostnames = undefined;
                            $scope.moreResults = 0;
                            this.search($scope.sonEntry.hostname).then((entries: Models.ISONDNSEntry[]) => {
                                if (entries.length > MAX_RESULTS_DISPLAYED) {
                                    $scope.moreResults = entries.length - MAX_RESULTS_DISPLAYED;
                                    entries = entries.slice(0, MAX_RESULTS_DISPLAYED);
                                }
                                this.$scope.matchedHostnames = entries;
                            });

                        }, 500);
                    }
                }
                return true;
            };

            if (this.nodeHostname) {
                this.sonAdapterService.getSONDnsMap(this.nodeHostname).then((dnsMap: Models.ISONDnsMap) => {
                    this.dnsMap = dnsMap;
                    $scope.matchedHostnames = undefined;
                    $scope.moreResults = 0;
                    this.search(this.nodeHostname).then((entries: Models.ISONDNSEntry[]) => {
                        if (entries.length > MAX_RESULTS_DISPLAYED) {
                            $scope.moreResults = entries.length - MAX_RESULTS_DISPLAYED;
                            entries = entries.slice(0, MAX_RESULTS_DISPLAYED);
                        }
                        this.$scope.matchedHostnames = entries;
                    });
                });
            }

            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.$scope.selectHostname = (index: number): boolean => {

                if (this.selectType === "block") {
                    this.close(this.$scope.matchedHostnames[index]);
                    return false;
                } else {
                    const matchedHostname: Models.ISONDNSEntry = this.$scope.matchedHostnames[index];
                    this.close(matchedHostname);
                }

            };
        }


        private search(fragment: string): Promise<Models.ISONDNSEntry[]> {
            if (this.selectType === "node") {
                if (this.networkNodeType.dnsModelName && this.networkNodeType.dnsModelName.length > 0) {
                    return this.getSONDNSHostnamesByModel(fragment, this.networkNodeType.dnsModelName);
                } else {
                    return this.getSONDNSHostnames(fragment);
                }
            } else {
                if (this.networkNodeType.hasSignalInterfaceDNS()
                    || !this.networkNodeType.dnsModelName
                    || this.networkNodeType.dnsModelName.length === 0) {
                    const filteredSignals: Models.ISONDNSEntry[] = this.dnsMap.findSignals().filter( (entry: Models.ISONDNSEntry) => {
                        return entry.hostname.indexOf(fragment) > -1;
                    });
                    return new Promise<Models.ISONDNSEntry[]>(
                        (resolve: (filteredSignals: Models.ISONDNSEntry[]) => Models.ISONDNSEntry[], reject: (err: Error) => void) => {
                        resolve(filteredSignals);
                    });
                } else {
                    return this.getSONDNSHostnamesByModel(fragment, this.networkNodeType.dnsModelName)
                        .then( (entries: Models.ISONDNSEntry[]) => {
                            return entries.filter( (entry: Models.ISONDNSEntry) => {
                                return entry.hostname.indexOf(this.nodeHostname) > -1 && !entry.isIpRange;
                            });
                        });
                }
            }
        }

        private getSONDNSHostnames(fragment: string): Promise<Models.ISONDNSEntry[]> {
            if (fragment.length >= 3)
                return this.sonAdapterService.searchSONDNSEntries(fragment) as Promise<Models.ISONDNSEntry[]>;
            else
                return Promise.resolve([]);
        }

        private getSONDNSHostnamesByModel(fragment: string, model: string): Promise<Models.ISONDNSEntry[]> {
            if (fragment.length >= 1)
                return this.sonAdapterService.searchSONDNSEntriesByModel(fragment, model) as Promise<Models.ISONDNSEntry[]>;
            else
                return Promise.resolve([]);
        }
    }
}